<!--
 * @Author: your name
 * @Date: 2021-04-26 18:32:29
 * @LastEditTime: 2021-12-07 19:51:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-business-components/src/view/TableInput.vue
-->
<!-- table表格中使用的input -->
<template>
  <div class="tableInput">
    <Form
      :label-width="100"
      style="width: 100%"
      :model="tableFormConfig.formValue"
      onsubmit="return false;"
    >
      <Row>
        <Col
          v-for="(item, index) in tableFormConfig.formData"
          :key="index"
          :span="item.width"
        >
          <!-- 日期選擇 -->
          <FormItem v-if="item.style === 'date'" :prop="item.value">
            <DatePicker
              :disabled="item.disabled"
              :type="'date'"
              split-panels
              :placeholder="item.placeholder"
              v-model="item.value"
              :format="item.format"
              :clearable="item.clearable"
              :transfer="true"
              @on-change="runMethods(item.onChange(item.value))"
            ></DatePicker>
          </FormItem>

          <!-- 時間選擇 -->
          <FormItem v-if="item.style === 'dateTime'" :prop="item.value">
            <TimePicker
              :disabled="item.disabled"
              :type="item.type ? item.type : 'time'"
              split-panels
              :placeholder="item.placeholder"
              v-model="item.value"
              :format="item.format"
              :clearable="item.clearable"
              :transfer="true"
              @on-change="dateTimeChange(item.dataTimeChange(item.value))"
            ></TimePicker>
          </FormItem>

          <!-- 输入框弹框单多选 -->
          <FormItem v-if="item.style === 'popInput'" class="popInput">
            <my-input
              :isActive="true"
              :isDisabled="false"
              :inputList="item.inputList ? item.inputList : []"
              :objList="item.objList ? item.objList : []"
              :itemdata="item.itemdata"
              @getFkChooseItem="runMethods(item.tableObj(item.itemdata))"
            ></my-input>
          </FormItem>

          <!-- 下拉选择 -->
          <FormItem
            v-if="item.style === 'select'"
            class="popSelect"
            :prop="item.value"
          >
            <Select
              @on-change="runMethods(item.selectChange($event))"
              v-model="item.value"
              :multiple="item.multiple ? item.multiple : false"
              :disabled="item.disabled"
              :transfer="true"
              :placeholder="item.placeholder ? item.placeholder : ''"
              :clearable="item.clearable"
              @on-clear="runMethods(item.clearSelect(item.value))"
            >
              <Option
                v-for="(option, index) in item.options"
                :key="index"
                :value="option.value"
                >{{ option.label }}</Option
              >
            </Select>
          </FormItem>

          <!-- 单选框 -->
          <FormItem v-if="item.style === 'checkbox'" :prop="item.value">
            <Checkbox
              v-model="item.value"
              :type="'checkbox'"
              @on-change="runMethods(item.radioChange(item.value))"
            ></Checkbox>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
// import myInput from "framework/components/input/objinput_dz.vue";
import myInput from "r3cps/components/input/objinput_dz.vue";
export default {
  name: 'TableInput',
  components: {
    myInput
  },
  data() {
    return {};
  },
  props: {
    tableFormConfig: {
      type: Object
    }
  },
  mounted() { },
  methods: {
    runMethods(val) {
      if (val) {
        val(e);
      }
    },
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$Message.success("Success!");
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
  }
};
// import TableInput from 'burgeonComponents/js/TableInput.js';
// export default TableInput;
</script>

<style lang="less" scoped>
@import "burgeonComponents/css/TableInput.less";
</style>

